<script lang="ts" setup>
const emit = defineEmits(["close"]);
defineProps({
  success: {
    type: Boolean,
    required: true,
  },
});
const localePath = useLocalePath();

const returnHomeAndLogout = () => {
  navigateTo(localePath("/"));
  useUserStore().logOut();
  useModalManager().closeModal("modal-rescue");
};

onMounted(() => {
  const rescueCookie = useCookie(`rescue-${useUserStore().id}`);
  const gfalIdRescue = useCookie(`gfalIdRescue-${useUserStore().id}`);
  rescueCookie.value = null;
  gfalIdRescue.value = null;
});

const returnToMarketplace = () => {
  navigateTo(localePath("/"));
  useModalManager().closeModal("modal-rescue");
};

onUnmounted(() => navigateTo(localePath("/")));
</script>

<template>
  <div class="flex flex-col items-center gap-6">
    <div class="my-6">
      <NuxtIcon
        v-if="success"
        name="mdi:check-circle-outline"
        class="w-24 h-24 text-success-300" />
      <NuxtIcon
        v-else
        name="mdi:cancel-circle-outline"
        class="w-24 h-24 text-error-300" />
    </div>

    <div class="flex flex-col justify-center items-center gap-2 -mt-6">
      <template v-if="success">
        <h3 class="text-xl font-bold text-neutral-200">
          {{ $t("main.modalRescue.rescueSuccessful") }}
        </h3>
        <p class="text-neutral-300 max-w-xs text-center">
          {{ $t("main.modalRescue.rescueSuccessfulDescription") }}
        </p>
      </template>
      <template v-else>
        <h3 class="text-xl font-bold text-error-300">
          {{ $t("main.modalRescue.rescueFailed") }}
        </h3>
        <p class="text-neutral-300 max-w-xs text-center">
          {{ $t("main.modalRescue.rescueFailedDescription") }}
        </p>
      </template>
    </div>

    <BaseButtonSubmit
      v-if="success"
      @click="returnToMarketplace"
      :text="$t('main.modalRescue.returnToMarketplace')" />
    <BaseButtonSubmit
      v-else
      @click="returnHomeAndLogout"
      :text="$t('main.modalRescue.close')" />
  </div>
</template>
